/**
 * Author : Komal Sadrani
 * Changes : Aaditya Gandhare
 * Modified : 13th Aug, 2018
 */

/**
 * Ext Libs
 */
import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-store';
import { BaseSettingsService } from '../../providers/base-settings.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  public websiteURL: string;
  public baseHREF: string;
  public sessionUser: any;

  /**
   * Initialize the class
   */
  constructor(private router: Router, private localStorage: LocalStorageService, private baseProvider: BaseSettingsService) {
    this.websiteURL = this.baseProvider.websiteURL;
    this.baseHREF = this.baseProvider.baseHREF;
  }

  /**
   * On Init Lifecycle Hook
   */
  ngOnInit() {
    // Check current ongoing session
    this.checkSession();
  }

  /**
   * Get Current Session
   */
  checkSession() {
    const customer = this.localStorage.get('customer-session');
    // Check If Customer ID Exists
    if (customer && customer.id) {
      this.sessionUser = customer;
    }
  }

  /**
   * Logout
   */
  logout() {
    this.localStorage.remove('customer-session');
    this.router.navigate(['/login']);
  }
}
